module.exports = __webpack_public_path__ + "img/footable.f6c396c9.svg";